"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Dropdown = void 0;
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var semantic_ui_react_1 = require("semantic-ui-react");
var DropdownIcon_1 = require("./DropdownIcon");
var utilities_1 = require("../../utilities");
var __1 = require("../");
var FormField_1 = require("../FormField");
var Dropdown = /** @class */ (function (_super) {
    __extends(Dropdown, _super);
    function Dropdown(props) {
        var _a;
        var _this = _super.call(this, props) || this;
        _this.handleSearch = function () {
            if (Array.isArray(_this.props.value)) {
                return _this.getOptionsWithoutValue(_this.state.options);
            }
            return _this.state.options;
        };
        _this.handleFocus = function (event, data) {
            var searchData = __assign(__assign({}, _this.props), { searchQuery: '' });
            _this.handleSearchChange(event, searchData);
            if (_this.props.onFocus) {
                _this.props.onFocus(event, data);
            }
        };
        _this.handleSearchChange = utilities_1.debounce(function (event, data) { return __awaiter(_this, void 0, void 0, function () {
            var options, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.setState({ loading: true });
                        _a = this.getOptionsWithValue;
                        return [4 /*yield*/, this.props.asyncOptions.dataFetcher(data.searchQuery)];
                    case 1:
                        options = _a.apply(this, [_b.sent()]);
                        this.setState({ options: options, loading: false });
                        if (this.props.onSearchChange) {
                            this.props.onSearchChange(event, data);
                        }
                        return [2 /*return*/];
                }
            });
        }); });
        _this.handleClearClick = function (event) {
            if (_this.props.onChange)
                _this.props.onChange(event, { value: undefined });
        };
        _this.getClearIcon = function () {
            if (_this.isEmptyValue || !_this.props.clearable) {
                return null;
            }
            return (react_1.default.createElement(__1.Icon, { name: "clear", className: "Select__clear-icon", onClick: _this.handleClearClick }));
        };
        _this.state = {
            loading: false,
            options: ((_a = props.asyncOptions) === null || _a === void 0 ? void 0 : _a.initial) || [],
        };
        _this.dropdownRef = react_1.default.createRef();
        return _this;
    }
    Dropdown.prototype.componentDidMount = function () {
        this.context.setFormFieldContext({ inputRef: this.dropdownRef });
    };
    Dropdown.prototype.getOptionsWithValue = function (options) {
        var _this = this;
        var values = this.arrayValue;
        var missingOptions = values
            .filter(function (value) {
            return options.findIndex(function (option) { return option.value === value; }) === -1;
        })
            .map(function (value) {
            return _this.state.options.find(function (option) { return option.value === value; });
        });
        if (missingOptions.length > 0) {
            options.push.apply(options, missingOptions);
        }
        return options;
    };
    Dropdown.prototype.getOptionsWithoutValue = function (options) {
        var values = this.arrayValue;
        var optionsWithoutValue = options.filter(function (option) {
            return values.findIndex(function (value) { return option.value === value; }) === -1;
        });
        return optionsWithoutValue;
    };
    Object.defineProperty(Dropdown.prototype, "isEmptyValue", {
        get: function () {
            return (this.props.value === undefined ||
                this.props.value === '' ||
                (Array.isArray(this.props.value) && this.props.value.length === 0));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Dropdown.prototype, "arrayValue", {
        get: function () {
            return this.isEmptyValue
                ? []
                : !Array.isArray(this.props.value)
                    ? [this.props.value]
                    : this.props.value;
        },
        enumerable: false,
        configurable: true
    });
    Dropdown.prototype.render = function () {
        var _a = this.props, asyncOptions = _a.asyncOptions, clearable = _a.clearable, className = _a.className, passedProps = __rest(_a, ["asyncOptions", "clearable", "className"]);
        var props = __assign({}, passedProps);
        props.className = classnames_1.default(className, {
            'Select--clearable': clearable,
        });
        if (asyncOptions) {
            props.search = this.handleSearch; // hijack search when data fetcher present as search happens remotely
            props.onSearchChange = this.handleSearchChange;
            props.onFocus = asyncOptions.fetchOnFocus
                ? this.handleFocus
                : props.onFocus;
            props.loading = this.state.loading;
            props.options = this.state.options;
        }
        return (react_1.default.createElement("div", { className: "semantic-anvil-theme Select-wrapper" },
            react_1.default.createElement(semantic_ui_react_1.Ref, { innerRef: this.dropdownRef },
                react_1.default.createElement(semantic_ui_react_1.Dropdown, __assign({}, props))),
            this.getClearIcon()));
    };
    Dropdown.Divider = semantic_ui_react_1.DropdownDivider;
    Dropdown.Header = semantic_ui_react_1.DropdownHeader;
    Dropdown.Item = semantic_ui_react_1.DropdownItem;
    Dropdown.Menu = semantic_ui_react_1.DropdownMenu;
    Dropdown.SearchInput = semantic_ui_react_1.DropdownSearchInput;
    Dropdown.defaultProps = {
        icon: react_1.default.createElement(DropdownIcon_1.DropdownIcon, null),
    };
    Dropdown.contextType = FormField_1.FormFieldContext;
    return Dropdown;
}(react_1.Component));
exports.Dropdown = Dropdown;
//# sourceMappingURL=Dropdown.js.map